import { render, staticRenderFns } from "./FooterFrench.vue?vue&type=template&id=5634c15b&"
import script from "./FooterFrench.vue?vue&type=script&lang=js&"
export * from "./FooterFrench.vue?vue&type=script&lang=js&"
import style0 from "./FooterFrench.vue?vue&type=style&index=0&id=5634c15b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports